import intlTelInput from "intl-tel-input";

let inputPhone = document.querySelectorAll(".input-phone");
if (inputPhone) {

	for (let i = 0; i < inputPhone.length; i++) {
		intlTelInput(inputPhone[i], {
			utilsScript: "/assets/js/utils.js",
			preferredCountries: [
				"de", "at", "ch",
			],
			localizedCountries: {
				"de": "Deutschland"
			},
			separateDialCode: false,
			autoHideDialCode: true,
			autoPlaceholder: "polite",
			nationalMode: false
		});
	}
}